export default function Footer() {
    const openForm = () => {
        document.getElementById("chatDiv").style.display = "block";
    };

    const closeForm = () => {
        document.getElementById("chatDiv").style.display = "none";
    };

    return (
        <>
            <footer>
                <div class="pad front">
                    <div class="data">
                        <div class="license">
                            <img src="images/big-logo.png" alt="" />
                            <div>
                                <a class="fbtn" target="_blank" href="#">License:</a>
                                <p>NuGenesis is a gasless, zero-carbon blockchain system designed for mass crypto adoption...</p>
                            </div>
                        </div>
                        <div class="groups"></div>
                        <div class="social">
                            <div>
                                <a href="#" target="_blank"><img src="images/github.svg" alt="GitHub" /></a>
                                <a href="#" target="_blank"><img src="images/discord.svg" alt="Discord" /></a>
                                <a href="https://web.facebook.com/nutechcity" target="_blank"><img src="images/facebook.svg" alt="Facebook" /></a>
                                <a href="#" target="_blank"><img src="images/medium.svg" alt="Medium" /></a>
                                <a href="#" target="_blank"><img src="images/telegram.svg" alt="Telegram" /></a>
                                <a href="https://x.com/nugenesisou" target="_blank"><img src="images/deadbird.svg" alt="Twitter/X" /></a>
                                <a href="https://www.linkedin.com/company/nugenesis" target="_blank"><img src="images/linkedin.svg" alt="LinkedIn" /></a>
                                <a href="https://www.youtube.com/@NuGenesis" target="_blank"><img src="images/youtube.svg" alt="YouTube" /></a>
                                <a href="https://www.tiktok.com/@cross.finance?_t=8hZemMgjyZm&_r=1" target="_blank"><img src="images/tiktok.svg" alt="TikTok" /></a>
                            </div>
                        </div>

                        {/* Open chat button */}
                        <div class="open-chat-button">
                            <button class="open-button" onClick={openForm} style={{ background: "none", border: "none", cursor: "pointer" }}>
                                <img src="images/nugenesisou/navis.png " alt="AI Bot" class="chatbotImg" />
                            </button>
                        </div>
                    </div>

                    <div class="foot">
                        <div>© 2025 NuGenesis</div>
                        <div></div>
                        <div>All rights reserved</div>
                    </div>
                </div>
            </footer>

            {/* Chat Popup */}
            <div class="chat-popup" id="chatDiv" >
                <div class="chat-popup-contain" style={{ position: "relative", width: "400px", height: "500px", backgroundColor: "#fff", borderRadius: "10px", boxShadow: "0px 4px 10px rgba(0,0,0,0.2)" }}>
                    <button type="button" class="btn cancel" onClick={closeForm} style={{ position: "absolute", top: "10px", right: "10px", zIndex: 10 }}>X</button>
                    <iframe
                        src="https://chatbot.nugenesisou.com"
                        title="insidecrypto"
                        width="100%"
                        height="100%"
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            border: "none",
                            pointerEvents: "auto"
                        }}
                        allow="fullscreen; clipboard-write; autoplay"
                    ></iframe>
                </div>
            </div>
        </>
    );
}
